import React from "react";
import { Box, Typography, Collapse, Checkbox, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface Item {
  key: string;
  label: string;
  description?: string;
  value: number;
  checked: boolean;
}

interface SupplierGroup {
  supplierGuid: string;
  supplierName: string;
  items: Item[];
}

interface SupplierGroupsListProps {
  supplierGroups: SupplierGroup[];
  openedGroupIndex: number | null;
  setOpenedGroupIndex: (index: number | null) => void;
  toggleItem: (groupIndex: number, itemIndex: number) => void;
  classes: Record<string, string>;
}

const formatCurrency = (value: number): string =>
  value.toLocaleString("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const SupplierGroupsList: React.FC<SupplierGroupsListProps> = ({
  supplierGroups,
  openedGroupIndex,
  setOpenedGroupIndex,
  toggleItem,
  classes,
}) => (
  <>
    {supplierGroups.map((group, supplierIndex) => {
      const total = group.items.reduce(
        (sum, item) => (item.checked ? sum + item.value : sum),
        0
      );

      return (
        <Box key={group.supplierGuid} className={classes.sectionWrapper}>
          <Box
            className={classes.sectionHeader}
            onClick={() =>
              setOpenedGroupIndex(
                openedGroupIndex === supplierIndex ? null : supplierIndex
              )
            }
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "15.5px",
                fontFamily: "Montserrat",
              }}
            >
              <span style={{ marginRight: 8 }}>{group.supplierName}</span>
              <Box className={classes.totalAmountChip}>
                {formatCurrency(total)} ₽
              </Box>
            </Typography>

            <IconButton size="small">
              <ExpandMoreIcon
                sx={{
                  transform:
                    openedGroupIndex === supplierIndex
                      ? "rotate(0deg)"
                      : "rotate(-90deg)",
                  transition: "transform 0.2s ease-in-out",
                }}
              />
            </IconButton>
          </Box>

          <Collapse in={openedGroupIndex === supplierIndex}>
            <Box mt={2}>
              {group.items.map((item, itemIndex) => (
                <Box key={item.key} className={classes.itemBox}>
                  <Box className={classes.itemRow}>
                    <label className={classes.itemLabel}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => toggleItem(supplierIndex, itemIndex)}
                        className={classes.checkbox}
                      />
                      <div className={classes.labelContent}>
                        <div className={classes.labelText}>
                          <span className={classes.labelPurple}>
                            {item.label}
                          </span>
                          {item.description && (
                            <small className={classes.description}>
                              {item.description}
                            </small>
                          )}
                        </div>
                        <span className={classes.amount}>
                          {formatCurrency(item.value)} ₽
                        </span>
                      </div>
                    </label>
                  </Box>
                </Box>
              ))}
            </Box>
          </Collapse>
        </Box>
      );
    })}
  </>
);
